import colormap from "colormap";

export const colormaps = [
  "jet",
  "hsv",
  "hot",
  "cool",
  "spring",
  "summer",
  "autumn",
  "winter",
  "bone",
  "copper",
  "greys",
  "YIGnBu",
  "greens",
  "YIOrRd",
  "bluered",
  "RdBu",
  "picnic",
  "rainbow",
  "portland",
  "blackbody",
  "earth",
  "electric",
  "viridis",
  "inferno",
  "magma",
  "plasma",
  "warm",
  "cool",
  "rainbow-soft",
  "bathymetry",
  "cdom",
  "chlorophyll",
  "density",
  "freesurface-blue",
  "freesurface-red",
  "oxygen",
  "par",
  "phase",
  "salinity",
  "temperature",
  "turbidity",
  "velocity-blue",
  "velocity-green",
  "cubehelix",
];

/**
 * Returns a color from a specified colormap based on a normalized value and alpha transparency.
 *
 * @param {string} type - The name of the colormap to use. If not found, defaults to "viridis".
 * @param {number} normValue - The normalized value (between 0 and 1) to map to a color.
 * @param {number} [alpha=1] - The alpha transparency value (between 0 and 1). Defaults to 1 (opaque).
 * @returns {string} The resulting color in hex format with alpha channel (e.g., "#RRGGBBAA").
 */
export function getColorMapColor(type, normValue, alpha = 1) {
  const norm = Math.max(0, Math.min(1, normValue));
  let colormapType = type;
  const colors = colormap({
    colormap: colormapType,
    nshades: 256,
    format: "hex",
    alpha: 1, // not useful for transparency
  });
  const idx = Math.round(norm * (colors.length - 1));
  const hex = colors[idx].replace("#", "");
  const alphaHex = Math.round(alpha * 255)
    .toString(16)
    .padStart(2, "0")
    .toUpperCase();
  return `#${hex}${alphaHex}`;
}
